import React, { useRef } from 'react';
import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import './style/index.less'

type Props = {
  // 数据
  data: any;
  // 滚动事件
  onScroll: () => void;
  // 卡片
  card: (item: any) => JSX.Element;
  // 预加载高度
  preloadingHeight?: number;
  // 禁用滚动
  disableScroll?: boolean;
}
const Content = (props: Props) => {
  const {
    data = [],
    onScroll = () => { },
    card,
    preloadingHeight = 640,
    disableScroll = false
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const disableScrollRef = useRef(disableScroll)

  /**
    * @description 滚动加载
    */
  const handleOnScroll = () => {
    if (disableScrollRef.current) return
    if (containerRef.current) {
      const { scrollTop: contentScrollTop, clientHeight, scrollHeight } = containerRef.current

      if (contentScrollTop + clientHeight >= scrollHeight - preloadingHeight) {
        /* 处理业务 */
        onScroll()
      }
    }
  };
  const handleOnScrollDebounced = debounce(handleOnScroll, 200);


  useEffect(() => {
    disableScrollRef.current = disableScroll
  }, [disableScroll])
  return (
    <div className='box'>
      <div
        className='container'
        ref={containerRef}
        onScrollCapture={handleOnScrollDebounced}
      >
        {
          data?.map((item: any, index: number) => {
            return <div className='card-item' key={index}>
              {card(item)}
            </div>
          })
        }
      </div>
    </div>
  );
}
export default Content;
